/**
 * @description 统一处理公共请求头和状态码判断
 * * 该H5子服务目前对接底座、云城的接口服务，请求的接口域名、公共请求头和返回成功的判断等可能不一致，通过这里面的函数分开处理
 *
 */
import request from '@/axios/index.js';
import { Toast } from 'vant';
import store from '@/store';

const startLoading = () => {
  return Toast.loading({
    message: '请稍后...',
    forbidClick: true,
    duration: 0,
  });
};

const origin = location.origin;
console.log('origin', origin);

/**
 * @description 底座接口统一处理
 * * @param {*} axiosParams 传入axios的参数
 * * @param {*} otherParams 其他配置参数，showLoading:是否展示loading，showErrorToast:请求失败是否展示toast，isNeedProjectCode:请求参数是否默认加上项目编码
 *
 */
export const apiRequest = async (axiosParams, otherParams) => {
  let { url, data = {}, params = {}, method = 'get', headers = {}, timeout } = axiosParams;
  const {
    showErrorToast = false,
    showLoading = false,
    isNeedProjectCode = true, // 是否需要自动加上项目编码参数
    baseUrl,
  } = otherParams || {};
  let loading = null;
  try {
    showLoading && (loading = startLoading());
    // 公共请求头
    const token = store.getters['token'];
    let commonHeaders = {};
    if (
      token &&
      !url.match(/login|getTokenByCode/g) &&
      (!baseUrl || baseUrl.indexOf('api-ioc.icloudcity.com') < 0)
    ) {
      commonHeaders['Blade-Auth'] = `bearer ${token}`;
      commonHeaders['Authorization'] = `Basic c2FiZXI6c2FiZXJfc2VjcmV0`;
      commonHeaders['clientOSType'] = 'miniapp';
    }
    const projectCode = store.getters.parkCode;
    if (isNeedProjectCode) {
      if (method.toLowerCase() === 'get' && projectCode && !params.projectCode) {
        params.projectCode = projectCode;
      } else if (method.toLowerCase() === 'post' && projectCode && !data.projectCode) {
        data.projectCode = projectCode;
      }
    }
    if (url.indexOf('api/enterprise-platform') > -1) {
      url = url.replace('api/enterprise-platform', 'api/residential-mt');
    } else if (url.indexOf('api/enterprise-app') > -1) {
      url = url.replace('api/enterprise-app', 'api/residential-mt');
    }
    const res = await request({
      url: baseUrl ? `${baseUrl}${url}` : `${origin}${url}`,
      method,
      data,
      params,
      headers: { ...commonHeaders, ...headers },
      timeout,
    });

    showLoading && loading.clear();
    // ioc的接口返回编码100000
    if (
      res.code === 200 ||
      res.code == 100000 ||
      url.indexOf('parkBaseInfo/getParkByCode') > -1 ||
      url.indexOf('pay/transactions') > -1 ||
      res.ret == '0' ||
      typeof res =='string'

    ) {
      return Promise.resolve(res);
    } else {
      showErrorToast && Toast.fail(res.msg || res.message || '请求异常，请稍后重试');
      return Promise.reject(res);
    }
  } catch (error) {
    console.warn(error);
    showLoading && loading.clear();
    return Promise.reject(error);
  }
};

/**
 * @description 云城接口统一处理
 * * @param {*} axiosParams 传入axios的参数
 * * @param {*} otherParams 其他配置参数，showLoading:是否展示loading，showErrorToast:请求失败是否展示toast
 *
 */
export const ycApiRequest = async (axiosParams, otherParams) => {
  let { url, data = {}, params = {}, method = 'get', headers = {}, timeout } = axiosParams;
  const { showErrorToast = false, showLoading = false, baseUrl } = otherParams || {};
  let loading = null;
  try {
    showLoading && (loading = startLoading());
    // 公共请求头
    const ycToken = store.getters['ycToken'];
    let commonHeaders = {};
    if (ycToken && !url.match(/login|access_token/g)) {
      commonHeaders['Authorization'] = `Bearer ${ycToken}`;
    }

    const endpoint =
      process.env.NODE_ENV === 'development' ? '/apiv1/' : store.getters.entryQuery?.endpoint || '';
    const fullUrl = baseUrl ? `${baseUrl}${url}` : `${endpoint}${url}`;
    const nurl = fullUrl.replace('api/', 'apiv1/');
    const res = await request({
      url: nurl,
      method,
      data,
      params,
      headers: { ...commonHeaders, ...headers },
      timeout,
    });

    showLoading && loading.clear();
    if (res.ret == '0') {
      return Promise.resolve(res);
    } else {
      showErrorToast && Toast.fail(res.msg || '请求异常，请稍后重试');
      return Promise.reject(res);
    }
  } catch (error) {
    console.warn(error);
    showLoading && loading.clear();
    return Promise.reject(error);
  }
};
